<template>
  <main-menu-item target="_blank"
                  v-bind:icon="icon"
                  v-bind:label="label"
                  v-on:click="onClicked"/>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {Browser} from '@capacitor/browser'
import MainMenuItem from '@/components/common/menu/MainMenuItem.vue'

export default defineComponent({
  name: 'open-pdf-menu-item',
  props: {
    label: String,
    icon: String,
    href: String
  },
  methods: {
    async onClicked() {
      if (!this.href) return
      // Ouvre le PDF dans le navigateur natif ou une app compatible
      await Browser.open({ url: this.href })
    }
  },
  components: {
    MainMenuItem
  }
})
</script>

<style scoped>
</style>
